import React from 'react'
import {Tab} from 'semantic-ui-react'
import {Typography} from '@mui/material';
var data='Sin contenido'
var dataContenido = 'No se muestran datos'
var dataDriver = 'No se muestran datos'
const panes = [
  {
    menuItem: 'Datos de Orden',
    render: () => <Tab.Pane attached={false}>{data}</Tab.Pane>,
  },
  {
    menuItem: 'Contenido de Orden',
    render: () => <Tab.Pane attached={false}>{dataContenido}</Tab.Pane>,
  },
  {
    menuItem: 'Datos de driver',
    render: () => <Tab.Pane attached={false}>{dataDriver}</Tab.Pane>,
  },
]
const translateState = {
  'C0E':'Esperando Confirmacion',
  'C01':'Programado para retiro',
  'C02':'Programado para retiro',
  'C03':'Programado para retiro',
  'R01':'En ruta de entrega',
  'R02':'En ruta de entrega',
  'R03':'En ruta de entrega',
  'R04':'En ruta de entrega',
  'R05':'Entregado',
  'R06':'Entregado',
  'CA1':'No se logro entregar',
  'CA2':'No se logro entregar',
  'CA3':'No se logro entregar',
  'CA4':'No se logro entregar',
  }
  const styleState = {
    'C0E':'alert alert-primary',
    'C01':'alert alert-info',
    'C02':'alert alert-info',
    'C03':'alert alert-info',
    'R01':'alert alert-success',
    'R02':'alert alert-success',
    'R03':'alert alert-success',
    'R04':'alert alert-success',
    'R05':'alert alert-success',
    'R06':'alert alert-success',
    'CA1':'alert alert-danger',
    'CA2':'alert alert-danger',
    'CA3':'alert alert-danger',
    'CA4':'alert alert-danger',
    }



const TabSecondary = (props) => {

// console.log(props.orderDetails)
 // data = props.orderDetails.originUserName

  data = (  <>   
  <h3>Datos Origen</h3>        
  <Typography color="textPrimary" gutterBottom variant="body">Nombre de Usuario:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.originUserName}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Dirección:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.originAddress}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Ciudad:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.originAdressCity}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Comuna:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.originAdressComuna}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Dirección:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.originAdressName}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Numero:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.originAdressNumAddress}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Teléfono:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.originAdressPhone}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Región:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.originAdressRegion}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Compañia:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.originCompanyAsignament}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">ID Propietario:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.originPropietary}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Comentario de dirección:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.originAdressComent}</Typography>
  
  <h3>Datos Destino</h3>
               
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Nombre:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.toUserName}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Destino:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.toAddress}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Numero:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.toAdressNumAddress}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Teléfono:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.toAdressPhone}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Ciudad:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.toAdressCity}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Comuna:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.toAdressComuna}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Comentario de dirección::</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.toAdressComent}</Typography>
  </>)

  dataContenido=(<>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Estatus:</Typography>   <Typography color="textPrimary" gutterBottom variant="body"><span className={styleState[props.orderDetails.dispachtCurrentStatus]}>{translateState[props.orderDetails.dispachtCurrentStatus]}</span></Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Curier:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.courierID}</Typography> 
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Contenido:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.packageContent}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Código Producto:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.packageContentID}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Descripción:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.packageContentnName}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Detalle:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.packageContentDescripcion}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Cantidad:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.packageContentQuantity}</Typography>      
 </>)

  dataDriver = (<>                 
  <Typography color="textPrimary" gutterBottom variant="body">ID:</Typography>  <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.dispachtCode}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Foto:</Typography>   <Typography color="textPrimary" gutterBottom variant="body"><img id="imgavatar" src={props.orderDetails.courierDriverAvatar}></img></Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Nombre:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.courierDriverName}</Typography>
  <hr></hr>
  <Typography color="textPrimary" gutterBottom variant="body">Teléfono:</Typography>   <Typography color="textPrimary" gutterBottom variant="body">{props.orderDetails.courierDriverPhone}</Typography>
  </>)

return(<Tab menu={{ secondary: true }} panes={panes}></Tab>
)
} 

export default TabSecondary